import { designTokenToColor } from '@src/utils';

export type ButtonColors = {
  backgroundColor: string | undefined;
  textColor: string;
  hoverBackgroundColor: string;
  pressedBackgroundColor: string;
  focusedBorderColor: string;
  disabledBackgroundColor: string | undefined;
  disabledTextColor: string;
  borderWidth?: string | undefined;
  borderColor: string | undefined;
};

const CONTAINED = {
  focusedBorderColor: designTokenToColor('state.teal.secondary'),
  disabledBackgroundColor: designTokenToColor('controls.backing+line'),
  disabledTextColor: designTokenToColor('text.disabled'),
  borderColor: undefined,
};

const CONTAINED_PRIMARY: ButtonColors = {
  ...CONTAINED,
  backgroundColor: designTokenToColor('state.teal.primary'),
  textColor: designTokenToColor('surface.paper'),
  hoverBackgroundColor: '#003947',
  pressedBackgroundColor: '#002933',
};

const CONTAINED_SECONDARY: ButtonColors = {
  ...CONTAINED,
  backgroundColor: designTokenToColor('state.teal.backing-1'),
  textColor: designTokenToColor('state.teal.primary'),
  hoverBackgroundColor: '#C3EFED',
  pressedBackgroundColor: '#AFE9E7',
};

const CONTAINED_DESTRUCTIVE: ButtonColors = {
  ...CONTAINED,
  backgroundColor: designTokenToColor('state.error.secondary'),
  textColor: designTokenToColor('surface.paper'),
  hoverBackgroundColor: '#6A1E16',
  pressedBackgroundColor: designTokenToColor('state.error.primary'),
  focusedBorderColor: designTokenToColor('state.error.primary'),
};

const OUTLINED: ButtonColors = {
  backgroundColor: undefined,
  textColor: designTokenToColor('text.secondary'),
  hoverBackgroundColor: designTokenToColor('state.teal.backing'),
  pressedBackgroundColor: designTokenToColor('state.teal.backing-1'),
  focusedBorderColor: designTokenToColor('state.teal.secondary'),
  disabledBackgroundColor: undefined,
  disabledTextColor: designTokenToColor('text.disabled'),
  borderColor: designTokenToColor('controls.outline'),
  borderWidth: '1px',
};

const TEXT_PRIMARY: ButtonColors = {
  backgroundColor: undefined,
  textColor: designTokenToColor('state.teal.secondary'),
  hoverBackgroundColor: designTokenToColor('state.teal.backing'),
  pressedBackgroundColor: designTokenToColor('state.teal.backing-1'),
  focusedBorderColor: designTokenToColor('state.teal.secondary'),
  disabledBackgroundColor: undefined,
  disabledTextColor: designTokenToColor('text.disabled'),
  borderColor: undefined,
};

const TEXT_DESTRUCTIVE: ButtonColors = {
  backgroundColor: undefined,
  textColor: designTokenToColor('state.error.secondary'),
  hoverBackgroundColor: designTokenToColor('state.error.backing'),
  pressedBackgroundColor: designTokenToColor('state.error.backing-1'),
  focusedBorderColor: designTokenToColor('state.error.primary'),
  disabledBackgroundColor: undefined,
  disabledTextColor: designTokenToColor('text.disabled'),
  borderColor: undefined,
};

export { CONTAINED_PRIMARY, CONTAINED_SECONDARY, CONTAINED_DESTRUCTIVE, OUTLINED, TEXT_PRIMARY, TEXT_DESTRUCTIVE };